import { render, staticRenderFns } from "./IdentificationInformation.vue?vue&type=template&id=edb0aa8a&scoped=true"
import script from "./IdentificationInformation.vue?vue&type=script&lang=js"
export * from "./IdentificationInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb0aa8a",
  null
  
)

export default component.exports